import { ProfileImage } from '@/interface/profile';

/**
 * Pull `MemberKeyNumeric` / `TeamKeyNumeric` out of a `/profile-image` response.
 *
 * The payload has carried the member key at two different depths, so the
 * top-level key wins and the nested `Member` object is the fallback.
 *
 * Returns `undefined` — never `0` — for a missing key, so callers keep the
 * choice of default. `/chat_stream` treats `0` as a real member key.
 */
export const extractMemberKeys = (
  res?: ProfileImage | null,
): { memberKeyNumeric?: number; teamKeyNumeric?: number } => {
  const data = res?.value?.[0];

  return {
    memberKeyNumeric: data?.MemberKeyNumeric ?? data?.Member?.MemberKeyNumeric,
    teamKeyNumeric: data?.TeamKeyNumeric,
  };
};
